import api from "@/api";
import { formatToFileName } from "@/util.js";

const state = () => ({
  data: [],
  menuAsFeatured: false,
});

const noProducts = (data) => {
  if (!data) {
    return;
  }
  return data.every(
    (department) => department.products && !department.products.length
  );
};

const actions = {
  async fetch({ commit, dispatch }) {
    const data = await api({
      url: "/123/web/products",
    });
    data.err
      ? dispatch("error/showError", data.err, { root: true })
      : noProducts(data.info)
      ? commit(
          "notification/SHOW",
          "Sorry products didn't load. Please refresh the page.",
          { root: true }
        )
      : commit("UPDATE", data.info);

    const menu = data.info.find((dept) => dept.category_id === "Menu");
    menu && dispatch("menu/update", menu.products, { root: true });
    menu && commit("ADD_SPECIALS_SUB_CATEGORY");
  },
};

const addDefaultDepartmentImage = (dept) => {
  return { ...dept, src: formatToFileName(dept.name) };
};

const addSpecialsSubCategory = (dept) => {
  if (dept.category_id === "Menu") {
    if (
      dept.products.find((product) => product.pricebook_info.promotions.length)
    ) {
      dept.sub_categories.unshift({
        category_id: "oneclick_page_category_Specials",
        category_name: "Specials",
        name: "Specials",
      });
    }
  }
  return dept;
};

const mutations = {
  UPDATE(state, payload) {
    state.data = payload.map(addDefaultDepartmentImage);
  },
  ADD_SPECIALS_SUB_CATEGORY(state) {
    state.data = state.data.map(addSpecialsSubCategory);
  },
  UPDATE_MENU_AS_FEATURED(state, payload) {
    state.menuAsFeatured = payload;
  },
};

const getters = {
  getDepartmentDisplayName: (state) => (id) => {
    let department = state.data.find((dep) => dep.category_id == id);
    if (!department) return;
    if (department.name == "Menu" && state.menuAsFeatured) {
      return "Featured";
    }
    return department.name;
  },
  getDepartmentSrc: (state) => (id) => {
    let department = state.data.find((dep) => dep.category_id == id);
    if (department.name == "Menu" && state.menuAsFeatured) {
      return "featured";
    }
    return department.src;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
